import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, from, Observable } from 'rxjs';
import { Router } from '@angular/router';
import { environment } from '../../../environments/environment';
import { Messaging, getToken } from '@angular/fire/messaging';
import { Auth, onIdTokenChanged } from '@angular/fire/auth';
import { getAuth, signInWithEmailAndPassword } from 'firebase/auth';
import { Firestore, doc, setDoc, addDoc, collection } from '@angular/fire/firestore';

@Injectable({
	providedIn: 'root'
})
export class MessagingService {
	constructor(private messaging: Messaging, private auth: Auth, private firestore: Firestore) {
		/* const firebaseAuth = getAuth();
		onIdTokenChanged(firebaseAuth, (user) => {
			console.log(user)
			if (user) {
				user.getIdToken().then((token) => {
					console.log('ID Token:', token);
				});
			} else {
				console.log('User is signed out');
			}
		}); */
	}

	requestPermission() {
		return Notification.requestPermission();
	}

	login() {
		return signInWithEmailAndPassword(this.auth, "dummymail@technicious.in", "Tech@123");
	}

	addVideoCallEntry(docData: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", docData.apptId.toString());
		return setDoc(docRef, docData, { merge: true });
	}

	updateToTriggerSnapshotChange(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { apptId: apptId.toString() }, { merge: true });
	}

	allowCandidateToJoin(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { candidateCanJoin: 2 }, { merge: true });
	}

	notallowCandidateToJoin(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { candidateCanJoin: 3 }, { merge: true });
	}

	setCandidateOnline(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { candidateOnline: true }, { merge: true });
	}

	setCandidateOffline(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { candidateOnline: false, candidateCanJoin: 1 }, { merge: true });
	}

	setTestCompleted(apptId: any): Promise<void> {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { testCompleted: true, candidateOnline: false, candidateCanJoin: 1 }, { merge: true });
	}

	sendMessageInVideoCall(msgObj: any) {
		const usersRef = collection(this.firestore, 'chat');
		return addDoc(usersRef, msgObj);
	}

	addRandomCandidateId(randomCandidateId: any, apptId: any) {
		const docRef = doc(this.firestore, "videocall", apptId.toString());
		return setDoc(docRef, { randomCandidateId: randomCandidateId }, { merge: true });
	}
}
